import { Fragment } from 'react'
import { Translate } from 'react-redux-i18n'
import { formatText } from '../../../../helpers/value'
import { Checkbox } from '../../../html/checkbox'
import { CustomPrice } from '../../customPrice'
import { BLOCK_CONFIG, BLOCK_TYPE } from '../constants'
import classes from './index.module.scss'
import { ScoreReportingDate } from './ScoreReportingDate'

export const ListCheckbox = ({
  data,
  ids,
  checked,
  onCheckboxChange,
  allowChange,
  style,
  isHiddenPrice,
}) => {
  return (
    <div className={classes.gridContent} style={{ gap: 12, ...style }}>
      {ids.map((id) => {
        return (
          data[id] && (
            <Fragment key={id}>
              <div className="dFlex alignItemsCenter">
                <Checkbox
                  title={formatText(data[id].name)}
                  value={id}
                  checked={checked[id]}
                  className="fw600"
                  isCheckOnClickText
                  isI18n
                  allowChange={
                    allowChange === undefined
                      ? BLOCK_CONFIG[id].allowChange
                      : allowChange
                  }
                  onChange={(value) => onCheckboxChange(id, value)}
                />
                {id === BLOCK_TYPE.SCORE && (
                  <ScoreReportingDate val={data[id].reportingDate} />
                )}
              </div>
              <div className="dFlex justifyContentEnd pr3">
                {!isHiddenPrice && (
                  <>
                    {id !== BLOCK_TYPE.INDUSTRY ? (
                      <CustomPrice
                        isShowIcon
                        value={data[id].price}
                        style={{
                          color: '#0553A5',
                          fontSize: 14,
                          fontWeight: '600',
                        }}
                      />
                    ) : (
                      <Translate value="domesticSearchPreview.FREE_WHEN_PURCHASE" />
                    )}
                  </>
                )}
              </div>
            </Fragment>
          )
        )
      })}
    </div>
  )
}
